import ReactEChartsCore from 'echarts-for-react/lib/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Flex from '@/components/common/Flex';
import { RadarChart } from 'echarts/charts';
import * as echarts from 'echarts/core';
import {
  breakpointsMediaQuery,
  getColor,
  percentageOfAll,
  rgbaColor,
  useMediaQuery
} from '@/helpers/utils';
import React, { useRef } from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import {
  GridComponent,
  LegendComponent,
  TitleComponent,
  TooltipComponent
} from 'echarts/components';
import { CanvasRenderer } from 'echarts/renderers';

import _ from 'lodash';
import chroma from 'chroma-js';
import timeStampToDate from '@/helpers/timeStampToDate';
import HelpTooltip from '@/app/common/components/HelpTooltip';
import FalconCardHeader from '@/components/common/FalconCardHeader';
import CardDropdown from '@/components/common/CardDropdown';
import CustomLegent from '@/app/common/components/charts/CustomLegent';
import { useTooltipHide } from '@/hooks/useTooltipHide';
echarts.use([
  TitleComponent,
  TooltipComponent,
  GridComponent,
  RadarChart,
  CanvasRenderer,
  LegendComponent
]);
const seriesGenerator = data => {
  return [
    {
      symbolSize: 7,
      symbol: 'circle',
      type: 'radar',
      name: 'رتبه فعلی',
      data: [
        {
          name: 'رتبه فعلی',
          itemStyle: {
            color: getColor('primary')
          },
          areaStyle: {
            color: rgbaColor(getColor('primary'), 0.24)
          },
          value: data.map(item => item.value)
        }
      ],
      avoidLabelOverlap: false,
      emphasis: {
        scale: false
      },

      label: {
        show: false,
        position: 'center',
        fontSize: 23,
        color: getColor('gray-1100'),
        fontWeight: 600
      }
    },
    {
      symbolSize: 7,
      symbol: 'circle',
      type: 'radar',
      name: 'اولین رتبه',
      data: [
        {
          name: 'اولین رتبه',
          itemStyle: {
            color: getColor('secondary')
          },
          areaStyle: {
            color: rgbaColor(getColor('secondary'), 0.24)
          },
          value: data.map(item => item.first)
        }
      ],
      avoidLabelOverlap: false,
      emphasis: {
        scale: false
      },

      label: {
        show: false,
        position: 'center',
        formatter: '{a}',
        fontSize: 5,
        color: getColor('gray-1100'),
        fontWeight: 600
      }
    }
  ];
};
const getOptions = (data, firstDate, lastDate, isMdUp) => ({
  textStyle: {
    fontFamily: 'dana'
  },
  legend: { show: false },
  // color: data.map(item => getColor(item.color)),
  tooltip: {
    triggerOn: isMdUp ? 'mousemove' : 'click',
    trigger: 'item',
    padding: [7, 10],
    transitionDuration: 0,
    backgroundColor: getColor('gray-100'),
    borderColor: getColor('gray-300'),
    textStyle: { color: getColor('gray-1100'), fontFamily: 'dana !important' },
    borderWidth: 1,
    axisPointer: {
      type: 'none'
    },
    // confine: true,
    formatter: params => {
      const tooltipFormattedData = data.sort((a, b) => b.id - a.id);
      const mode = params.seriesIndex === 0 ? true : false;
      let tooltipItem = ``;

      const totalCount = _.sum(
        data.map(item => item[mode ? 'value' : 'first'])
      );
      tooltipFormattedData.forEach(el => {
        tooltipItem =
          tooltipItem +
          `
            <div class="text-700 d-flex flex-row align-items-center justify-content-between w-100 gap-1">
            
              <span class="text-800 d-flex flex-row-reverse align-items-center gap-1">${el.name?.toString()?.toPersianDigit()} ${params.marker}</span>
              <span class="d-flex align-items-center gap-1">
              <span class="fw-light text-800 fs--1"> (${Number(
                percentageOfAll(el[mode ? 'value' : 'first'], totalCount)
              )
                .toFixed(0)
                .toString()
                ?.toPersianDigit()}%)</span>
              <span class="fw-bold text-1000">${el[mode ? 'value' : 'first']?.toString()?.toPersianDigit()}</span>
              </span>
              </div>`;
      });
      return `<div style="width:200px;" class="d-flex flex-column align-items-end">
                <p class='mb-2 text-1000 d-flex justify-content-between w-100 fw-bold'>
                <span>${params?.name}</span>
                  <span> 
                  ${timeStampToDate(Number(mode ? lastDate : firstDate))
                    .slice(8)
                    .toPersianDigit()}
                  </span>
                </p>
                ${tooltipItem}
              </div>`;
    }
  },

  radar: {
    nameGap: 10,
    indicator: data.map(item => {
      return {
        name: item.name,
        // max: _.sum(data.map(item => item.value)) منطق مکس
        max: _.max([
          ...data.map(item => item.value),
          ...data.map(item => item.first)
        ])
      };
    }),
    splitNumber: 7,
    radius: '75%',
    // radius: 30,
    axisLine: {
      show: true,
      symbol: 'circle',
      symbolSize: [13, 13],
      lineStyle: {
        color: {
          type: 'radial',
          x: 0.5,
          y: 0.5,
          r: 0.5,
          colorStops: [
            {
              offset: 0.7,
              color: getColor('gray-100')
            },
            {
              offset: 1,
              color: getColor('gray-400')
            }
          ]
        }
      }
    },
    splitArea: {
      show: false
    },
    splitLine: {
      lineStyle: {
        color: getColor('gray-300')
      }
    },
    axisName: {
      color: getColor('gray-600'),
      fontWeight: 500
    }
    // splitLine: {
    //   lineStyle: {
    //     color: rgbaColor(getColor('gray-700'))
    //   }
    // }
  },

  series: [...seriesGenerator(data)]
  // grid: { right: 5, left: 5, bottom: 5, top: 5 }
});
const ItemList = ({ data }) => {
  return (
    <>
      {data.map((item, index) => (
        <Flex
          key={index}
          alignItems="baseline"
          justifyContent="start"
          gap={3}
          className={`fw-semi-bold fs--2 gap-1 ${index == 0 && 'mt-1'}`}
        >
          <p className="mb-1">
            <FontAwesomeIcon
              icon="circle"
              size="sm"
              className="me-2"
              style={{ color: item?.itemStyle?.color }}
            />
            {item.name}:
          </p>
          <div className="fw-black">{item.value} </div>
          <div className="fw-light mx-1">({item.value - item.first}) </div>
        </Flex>
      ))}
    </>
  );
};
const CardRadarChart = ({ data, title, tooltip }) => {
  const palette = chroma
    .scale([
      chroma(getColor('primary')).brighten(2),
      chroma(getColor('primary')).darken(2)
    ])
    .mode('lab')
    .colors(6);
  const formattedData = [
    {
      id: 6,
      name: '1-3',
      value: _.sum(data[data.length - 1].ranks.slice(0, 2)),
      first: _.sum(data[0].ranks.slice(0, 2)),
      itemStyle: { color: palette[5] }
    },

    {
      id: 1,
      name: 'بدون رتبه',
      value: _.sum(data[data.length - 1].ranks.slice(100, 101)),
      first: _.sum(data[0].ranks.slice(100, 101)),
      itemStyle: { color: getColor('gray-500') }
    },
    {
      id: 2,
      name: '51-100',
      value: _.sum(data[data.length - 1].ranks.slice(50, 99)),
      first: _.sum(data[0].ranks.slice(50, 99)),
      itemStyle: { color: palette[1] }
    },
    {
      id: 3,
      name: '21-50',
      value: _.sum(data[data.length - 1].ranks.slice(20, 49)),
      first: _.sum(data[0].ranks.slice(20, 49)),
      itemStyle: { color: palette[2] }
    },
    {
      id: 4,
      name: '11-20',
      value: _.sum(data[data.length - 1].ranks.slice(10, 19)),
      first: _.sum(data[0].ranks.slice(10, 19)),
      itemStyle: { color: palette[3] }
    },
    {
      id: 5,
      name: '4-10',
      value: _.sum(data[data.length - 1].ranks.slice(3, 9)),
      first: _.sum(data[0].ranks.slice(3, 9)),
      itemStyle: { color: palette[4] }
    }
  ].slice();

  const cardRef = useRef();
  const chartRef = useRef();
  const isMdUp = useMediaQuery(breakpointsMediaQuery.md);
  useTooltipHide(chartRef);

  return (
    <Card ref={cardRef} className="h-md-100">
      <FalconCardHeader
        title={title}
        titleTag="h6"
        className="border-200 border-bottom py-2"
        endEl={<CardDropdown />}
      />
      {/* <Card.Header className="border-200 border-bottom py-2">
        <h6 className="mb-0">
          {title}
          <HelpTooltip html={tooltip} />
        </h6>
      </Card.Header> */}
      {/* <FalconCardHeader
        title={
          <div>
            {title}
            <HelpTooltip html={tooltip} />
          </div>
        }
        titleTag="h6"
        className="py-3"
        light
        endEl={<CardChartDropDown cardRef={cardRef} chartRef={chartRef} />}
      /> */}
      <Card.Body className="py-1">
        <Row className="justify-content-between g-0">
          {/* <Col xs={5} sm={6} xxl className="pe-2">
            <ItemList data={formattedData} />
          </Col> */}
          <Col xs={12} className="d-flex justify-content-center">
            <div className="ps-0">
              <ReactEChartsCore
                ref={chartRef}
                echarts={echarts}
                option={getOptions(
                  formattedData,
                  data[0]?.update_date,
                  data[data.length - 1]?.update_date,
                  isMdUp
                )}
                style={{ height: '296px', width: '300px' }}
              />
            </div>
          </Col>
        </Row>
        <div className="d-flex mt-n2 mb-3 gap-2 justify-content-center pt-1 align-items-center">
          {seriesGenerator(data).map(item => (
            <CustomLegent
              key={item.name}
              name={item.name}
              chartRef={chartRef}
              color={getColor('primary')}
            />
          ))}
        </div>
      </Card.Body>
    </Card>
  );
};

export default CardRadarChart;
